import { CheckIcon, HandThumbUpIcon, UserIcon } from '@heroicons/react/20/solid'
import Pagination from '../Table/Pagination'
import { ArrowTopRightOnSquareIcon } from '@heroicons/react/24/outline'

function classNames(...classes) {
    return classes.filter(Boolean).join(' ')
}

export default function Feeds({ events, pagination, onClick }) {
    return (
        <div className="flow-root">
            <ul role="list" className="-mb-8">
                {events.map((event, eventIdx) => (
                    <li key={event.id}>
                        <div className="relative pb-8">
                            {eventIdx !== events.length - 1 ? (
                                <span aria-hidden="true" className="absolute left-4 top-4 -ml-px h-full w-0.5 bg-gray-200" />
                            ) : null}
                            <div className="relative flex space-x-3">
                                <div>
                                    <span
                                        className={classNames(
                                            event.iconBackground,
                                            'flex size-8 items-center justify-center rounded-full ring-8 ring-white',
                                        )}
                                    >
                                        <event.icon aria-hidden="true" className="size-5 text-white" />
                                    </span>
                                </div>
                                <div className="grid grid-cols-3 min-w-0 flex-1 justify-between space-x-4 pt-1.5">
                                    <div>
                                        <p className="text-sm text-gray-500 text-wrap">
                                            {event.content}{' '}
                                            <a  className="font-medium text-gray-900 cursor-pointer" onClick={() => onClick(event)}>
                                                {event.target}
                                            </a>
                                        </p>
                                    </div>
                                    <div>
                                        {event.link && (
                                            <a href={event.link.href} className="font-bold text-sm text-blue-500 flex items-center gap-1">
                                                {event.link.name}
                                                <ArrowTopRightOnSquareIcon className="size-4" />
                                            </a>
                                        )}
                                    </div>
                                    <div className="whitespace-nowrap text-right text-sm text-gray-500">
                                        <time dateTime={event.datetime}>{event.date}</time>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </li>
                ))}
            </ul>
            <div className="mt-4">
                {pagination && <Pagination pagination={pagination} />}
            </div>
        </div>
    )
}
